import { isEmpty } from '../../../obj/dist/uswitch-ev-utils-obj.esm.js';
import '@babel/runtime/helpers/slicedToArray';
import '@babel/runtime/helpers/defineProperty';
import '../../../dist/objectSpread2-811c5212.esm.js';
import '@babel/runtime/helpers/typeof';
import '../../../nil/dist/uswitch-ev-utils-nil.esm.js';

var richTextFieldHasContent = function richTextFieldHasContent() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.values(content).some(function (element) {
    var _element$some;
    return (_element$some = element.some) === null || _element$some === void 0 ? void 0 : _element$some.call(element, function (i) {
      var _Object$values$some, _Object$values;
      return (i === null || i === void 0 ? void 0 : i.data) && !isEmpty(i.data) || (i === null || i === void 0 ? void 0 : i.value) || ((_Object$values$some = (_Object$values = Object.values(i)).some) === null || _Object$values$some === void 0 ? void 0 : _Object$values$some.call(_Object$values, function (it) {
        var _it$some;
        return (_it$some = it.some) === null || _it$some === void 0 ? void 0 : _it$some.call(it, function (_ref) {
          var value = _ref.value,
            _ref$content = _ref.content,
            innerContent = _ref$content === void 0 ? [] : _ref$content;
          return value || (innerContent === null || innerContent === void 0 ? void 0 : innerContent.some(function (ic) {
            return richTextFieldHasContent(ic);
          }));
        });
      }));
    });
  });
};

export { richTextFieldHasContent as default };
